import { render } from "./Images.vue?vue&type=template&id=3be465d2&scoped=true"
import script from "./Images.vue?vue&type=script&lang=ts"
export * from "./Images.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3be465d2"

export default script